import { createFileRoute } from '@tanstack/react-router';
import UserDetails from '../../../administration/src/components/Users/UserDetails';

export const Route = createFileRoute('/_secured/administration/users/$userId')({
  component: UserDetails,
});
